import InvoicePay from "@galarson/Handlers/PayInvoices";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentUserIsGuest } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import { PageProps } from "@insite/mobius/Page";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    isSignInPage: getCurrentPage(state).type === "SignInPage",
    userName: state.context.session.userName,
    currentUserIsGuest: getCurrentUserIsGuest(state),
    signInUrl: getPageLinkByPageType(state, "SignInPage")?.url,
});

const mapDispatchToProps = {
    InvoicePay
};

type Props = PageProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

export interface InvoiceDetailHeaderStyles {
    headerGridContainer?: GridContainerProps;
    title: TypographyProps;
    titleGridItem: GridItemProps;
    spinner?: LoadingSpinnerProps;
}

export const headerStyles: InvoiceDetailHeaderStyles = {
    titleGridItem: {
        width: 12,
        css: css`
            min-height: 40vh;
            justify-content: center;
            align-items: center;
        `
    },
    title: {
        variant: "h2",
        as: "h1",
        css: css`
        margin: 0px;
        font-family: Franklin Gothic Demi;
        font-size: 32px;
        font-weight: 600;
        text-transform: uppercase;
        `
    },
    headerGridContainer:{
        css: css`
        margin: 15px 0px;
        >div{
            align-items: center !important;
        }
        `
    }
};

const styles = headerStyles;
const PayInvoices = ({
    userName,
    currentUserIsGuest,
    isSignInPage,
    history,
    InvoicePay,
    signInUrl
}: Props) => {
    const [loading,setLoading] = React.useState(true);
    useEffect(() => {
        if ((!userName || currentUserIsGuest) && !isSignInPage) {
            history.push(`${signInUrl}`);
        } else {
            InvoicePay({});
        }
        return()=>{
            setLoading(false);
        }
    },[userName,currentUserIsGuest,isSignInPage]);

    if(loading){
        return <GridContainer {...styles.headerGridContainer}>
        <GridItem {...styles.titleGridItem}>
            <LoadingSpinner {...styles.spinner}/>
        </GridItem>
    </GridContainer>
    }

    return (
        <GridContainer {...styles.headerGridContainer}>
            <GridItem {...styles.titleGridItem}>
                <Typography {...styles.title}>{translate("Pay Invoices")}</Typography>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: withHistory(connect(mapStateToProps, mapDispatchToProps)(PayInvoices)),
    definition: {
        displayName: "Page Invoice",
        group: "Invoice Details"
    },
};

export default widgetModule;
